"use client";

import { ReactNode } from "react";
import { presets, Theme, ThemeUIProvider } from "@costar/theme-ui";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";

const key = "css-business-immo";
const cache = createCache({ key });

const { styles: _styles, ...rest } = presets.getBaseTheme("rem");

const theme = {
  ...rest,
  styles: {
    ..._styles,
    root: {
      ..._styles.root,
      "&": {
        "button:focus": { outline: "unset" },
        "a:hover": { color: "unset" },
      },
    },
  },
};

export const BIThemeUIProvider = (props: { children: ReactNode }) => (
  <CacheProvider value={cache}>
    <ThemeUIProvider theme={theme as unknown as Theme} useDivRootContext>
      {props.children}
    </ThemeUIProvider>
  </CacheProvider>
);
